import { local_grid2d_chunk_upsert } from '@/state/grid2d/grid2d_chunk/local_grid2d_chunk_upsert';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { FN_GRID2D_CELL__try_set_image } from './_methods/FN_GRID2D_CELL__try_set_image';

export function HANDLER_CLIENT__grid2d_chunk_upsert(items: any) {
  assert_array_instanceof(items, DTO__grid2d_chunk);

  for (let item of items) {
    item.cells_list.map(FN_GRID2D_CELL__try_set_image);
  }

  store.dispatch(local_grid2d_chunk_upsert(items));
}
